









import Vue from 'vue';
import CloseButton from '@/components/CloseButton.vue';

export default Vue.extend({
  name: 'PrivacyPolicy',
  components: {
    CloseButton,
  },
});
